import { render, staticRenderFns } from "./CheckoutDialog.vue?vue&type=template&id=130375e0&scoped=true"
import script from "./CheckoutDialog.vue?vue&type=script&lang=js"
export * from "./CheckoutDialog.vue?vue&type=script&lang=js"
import style0 from "./CheckoutDialog.vue?vue&type=style&index=0&id=130375e0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130375e0",
  null
  
)

export default component.exports